import { useMemo } from 'react';
import { type Control, INSTANCE_DIMENSION } from '../types/controls';

/** The controls a template owns, and which of them carries the instance scope. */
export type TemplateControls = {
  instanceControlKey: string | undefined;
  controlKeys: string[];
};

export const instanceControlKeyOf = (controls: Control[]): string | undefined =>
  controls.find((control) => control.dimension === INSTANCE_DIMENSION)?.key;

export const useTemplateControls = (controls: Control[]): TemplateControls =>
  useMemo(
    () => ({ instanceControlKey: instanceControlKeyOf(controls), controlKeys: controls.map((c) => c.key) }),
    [controls],
  );
